// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__V0v5m","title":"Info_title__70fHI","selects":"Info_selects__Rr9Nf","requiredAsterisk":"Info_requiredAsterisk__11dHg"};